import { useEffect, useState } from "react";
import { getData } from "src/actions/getData";
import PageHeader from "src/components/PageHeader";
import Table from "src/components/Table";
import FilterColumn from "src/components/Table/FilterColumn";
import { FilterFn } from "src/components/Table/FilterFn";
import { numberWithCommas } from "src/utils/thousandSeprator";
import { VscDebugRerun } from "react-icons/vsc";
import moment from 'jalali-moment';
import MiniInfoButton from "src/components/MiniInfoButton";
import ModalHeader from "src/components/Modal/ModalHeader";
import ModalBody from "src/components/Modal/ModalBody";
import ModalFooter from "src/components/Modal/ModalFooter";
import Modal from "src/components/Modal";
import TwinButton from "src/components/TwinButton";
import { get, post } from "src/services/HttpClient";
import { notify } from "src/services/Notification/Notification";
import WarehouseIssues from "./WarehouseIssues";

export default function QueueInvoices() {
    const [invoices, setInvoices] = useState();
    const [queueInvoices, setQueueInvoices] = useState();
    const [queueInvoicesDetail, setQueueInvoicesDetail] = useState();
    const [rowData, setRowData] = useState()
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [itemsStockSummary, setItemsStockSummary] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [reload, setReload] = useState(false)

    useEffect(() => {
        getData(setItemsStockSummary, "/sepidar/Inventory/getItemStockSummary")
    }, [])

    useEffect(() => {
        getData(setQueueInvoices, "/queue-invoices")
    }, [reload])

    useEffect(() => {
        getData((invoices) => {
            let filteredInvoices = invoices.filter(invoice => {
                if (invoice.customerPartyRef == 48 && invoice.state == 1) {
                    return true
                }
            })
            setInvoices(filteredInvoices)
        }, "/sepidar/invoices")
    }, [])

    useEffect(() => {
        if (queueInvoices && invoices) {
            let queueInvoicesDetail = queueInvoices.map(queueInvoice => ({ ...queueInvoice, ...invoices.find(invoice => invoice.note == queueInvoice.note) }))
            queueInvoicesDetail = queueInvoicesDetail.map(failedInvoice => {
                return {
                    ...failedInvoice,
                    status: failedInvoice.number ? "احتمالا فاکتور خروج نخورده" : "ثبت نشده",
                    color: failedInvoice.number ? "#c88812" : "#ec0f0f",
                }
            })
            setQueueInvoicesDetail(queueInvoicesDetail)
        }

    }, [queueInvoices, invoices])

    const columns = [
        {
            id: "number",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "شماره فاکتور",
        },
        {
            id: "type",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "نوع فروش",
        },
        {
            id: "status",
            cell: (info) => info.getValue() ? <MiniInfoButton text={info.getValue()} backgroundColor={`${info.row.original.color}15`} textColor={info.row.original.color} /> : "---",
            header: "وضعیت",
        },
        {
            id: "note",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "یادداشت",
        },
        {
            id: "createdAt",
            cell: (info) => (
                <>
                    {info.getValue()
                        ? moment
                            .from(info.getValue())
                            .locale("fa")
                            .format("jYYYY/jMM/jDD HH:mm")
                        : "---"}
                </>
            ),
            filterFn: (row, columnId, filterValue) => {
                // type can be "object" , "array" , "string" , "number"
                return FilterFn(row, columnId, filterValue, "date");
            },
            meta: {
                filterComponent: (setFilterValue) => {
                    return <FilterColumn setFilterValue={setFilterValue} type="date" />;
                },
            },
            header: "تاریخ ایجاد",
        },
        {
            id: "updatedAt",
            cell: (info) => (
                <>
                    {info.getValue()
                        ? moment
                            .from(info.getValue())
                            .locale("fa")
                            .format("jYYYY/jMM/jDD HH:mm")
                        : "---"}
                </>
            ),
            filterFn: (row, columnId, filterValue) => {
                // type can be "object" , "array" , "string" , "number"
                return FilterFn(row, columnId, filterValue, "date");
            },
            meta: {
                filterComponent: (setFilterValue) => {
                    return <FilterColumn setFilterValue={setFilterValue} type="date" />;
                },
            },
            header: "تاریخ آخرین ویرایش",
        },
        {
            id: "id",
            cell: (info) => (
                <div className="flex gap-2">
                    <div
                        className="cursor-pointer hover:bg-gray-100 hover:text-gray-600 transition-all ease-in-out duration-300 dark:bg-gray-700 bg-gray-50 text-gray-400 p-2 rounded-lg"
                        title="اجرا مجدد ثبت فاکتور"
                        onClick={() => {
                            setRowData(info.row.original)
                            setIsModalOpen(true)
                        }}
                    >
                        <VscDebugRerun className="text-red-500" />
                    </div>
                </div>
            ),
            header: "عملیات",
            footer: (info) => info.column.id,
            enableColumnFilter: false,
        },
    ];

    return (
        <>
            <PageHeader
                title="فاکتورهای خطادار"
            />
            <WarehouseIssues />
            <Table data={queueInvoicesDetail} columns={columns} />
            <Modal
                isOpen={isModalOpen}
                toggle={setIsModalOpen}
            >
                <ModalHeader>
                    اجرا مجدد فرآیند ثبت فاکتور
                </ModalHeader>
                <ModalBody>
                    <div className="p-4">

                        <div className="flex flex-col gap-2">
                            {
                                rowData?.number
                                    ?
                                    <span className="text-sm">فاکتور شماره {rowData?.number} به دلیل کسری موجودی، خروج از انبار نخورده است، تنها در صورتی عملیات ثبت مجدد قابل اجراست که کالاهای موجود در فاکتور موجودی داشته باشند و همینطور فاکتور فروش {rowData.number}  از سپیدار حذف شده باشد</span>
                                    :
                                    <span className="text-sm">اجرا این عملیات منجر به ثبت فاکتور فروش (و تلاش برای ثبت خروج انبار) خواهد شد، تنها در صورتی عملیات را اجرا کنید که از تامین موجودی کالاها مطمئن هستید</span>
                            }
                            <div className="w-full h-[1px] bg-gray-200 my-2"></div>
                            <span>اقلام فاکتور</span>
                            {
                                rowData?.invoicemeta?.map(item => {
                                    let itemStockSummary = itemsStockSummary.filter(stock => {
                                        if (stock?.code == item?.sku) {
                                            return true
                                        }
                                    })?.[0]
                                    return (
                                        <div className={`p-2 flex items-center justify-between gap-2 w-full border border-gray-200 rounded-xl ${itemStockSummary?.sepQuantity < item.quantity || !itemStockSummary ? "bg-red-100" : "bg-white"}`}>
                                            <div className="flex gap-2 items-center text-xs">
                                                <img className="w-14 border border-gray-100 rounded-xl" src={item?.image} />
                                                <div className="flex flex-col justify-center gap-1">
                                                    <div className="flex gap-1">
                                                        <span>
                                                            {item?.title}
                                                        </span>
                                                        <span>
                                                            ({item?.sku})
                                                        </span>
                                                    </div>
                                                    <div className="flex gap-2 items-center">
                                                        <div className="flex gap-1 items-center bg-gray-100 px-2 py-1 rounded-lg">
                                                            <span>{item.quantity}</span>
                                                            <span>عدد</span>
                                                        </div>
                                                        <div className="flex gap-1">
                                                            <span>شماره سفارش: </span>
                                                            <span>{item.orderId}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex items-center gap-1 mx-2 text-xs">
                                                <div className="flex flex-col gap-1">
                                                    <div>
                                                        <span>موجودی: </span>
                                                        <span>
                                                            {
                                                                itemStockSummary?.sepQuantity
                                                            }
                                                        </span>
                                                    </div>
                                                    <div>
                                                        {
                                                            itemStockSummary?.stockSummaryFa
                                                        }
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <TwinButton
                        acceptTitle={
                            rowData?.number
                                ?
                                false
                                :
                                "اجرا مجدد ثبت فاکتور"
                        }
                        acceptHandle={async () => {
                            let invoicemetaDetail = rowData?.invoicemeta.map(invoiceItem => ({ ...invoiceItem, ...itemsStockSummary.find(itemStockSummary => itemStockSummary.code == invoiceItem.sku) }))
                            let unavailableStocks = invoicemetaDetail.filter(item => {
                                if (item.quantity > item.sepQuantity) {
                                    return true
                                }
                            })
                            let undefinedStocks = invoicemetaDetail.filter(item => {
                                if (!item.sepQuantity) {
                                    return true
                                }
                            })

                            // return if invoice has unavailableStocks
                            if (unavailableStocks.length > 0) {
                                notify(`موجودی کالا(ها)ی ${unavailableStocks.map(item => item.sku).join(" , ")} کمتر از موجودی انبار است و فرآیند ثبت فاکتور نمی‌تواند اجرا شود`, "error");
                                return
                            }

                            if (undefinedStocks.length > 0) {
                                notify(` کالا(ها)ی ${undefinedStocks.map(item => item.sku).join(" , ")} در انبار تعریف نشده‌اند و فرآیند ثبت فاکتور نمی‌تواند اجرا شود`, "error");
                                return
                            }

                            setIsLoading(true)
                            let result = await post("/gen-invoice-again", {
                                invoiceId: rowData?.id
                            })
                            notify(result.message, result.success ? "success" : "error")
                            if (result.success) {
                                setReload(true)
                                // let syncResult = get("/sepidar/syncStocks?token=4LAcCKWxKRFGSP3pXDy8byog7a3YU8bqQJv")
                            }
                            setIsLoading(false);
                            setIsModalOpen(false)
                        }}
                        rejectTitle="بستن"
                        rejectHandle={() => { setIsModalOpen(false) }}
                        isCompact={true}
                        isLoading={isLoading}
                    />
                </ModalFooter>
            </Modal>
        </>
    )
}
